// Ces fonctions sont trouvables ici : https://locutus.io/php/
// Checks if the argument variable is empty
// undefined, null, false, number 0, empty string,
// string "0", objects without properties and empty arrays
// are considered empty
export function empty(mixed_var) {
    var undef, key, i, len;
    var emptyValues = [undef, null, false, 0, "", "0"];
    for (i = 0, len = emptyValues.length; i < len; i++) {
        if (mixed_var === emptyValues[i]) {
            return true;
        }
    }
    if (typeof mixed_var === "object") {
        for (key in mixed_var) {
            // TODO: should we check for own properties only?
            //if (mixed_var.hasOwnProperty(key)) {
            return false;
            //}
        }
        return true;
    }
    return false;
}
export function uniqid() {
    console.warn("ServiceMaint : Cette fonction est depréciée");
    var ts = String(new Date().getTime()), i = 0, out = '';
    for (i = 0; i < ts.length; i += 2) {
        out += Number(ts.substr(i, 2)).toString(36);
    }
    return ('d' + out);
}
/**
 * Gérer les quotes
 * @param {string} str Texte à analyser
 * @returns {String} Texte modifié
 */
export function addslashes(str) {
    return (str + '').replace(/[\\"']/g, '\\$&').replace(/\u0000/g, '\\0');
}
export function trim(str, charlist) {
    var whitespace;
    str += '';
    if (!charlist) {
        // default list
        whitespace = " \n\r\t\f\x0b\xa0\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u200b\u2028\u2029\u3000";
    }
    else {
        // preg_quote custom list
        charlist += '';
        whitespace = charlist.replace(/([\[\]\(\)\.\?\/\*\{\}\+\$\^\:])/g, '$1');
    }
    var l = str.length;
    for (var i = 0; i < l; i++) {
        if (whitespace.indexOf(str.charAt(i)) === -1) {
            str = str.substring(i);
            break;
        }
    }
    l = str.length;
    for (i = l - 1; i >= 0; i--) {
        if (whitespace.indexOf(str.charAt(i)) === -1) {
            str = str.substring(0, i + 1);
            break;
        }
    }
    return whitespace.indexOf(str.charAt(0)) === -1 ? str : '';
}
/**
 * Return default value if the value is null
 * @param {string} value1 Valeur initiale
 * @param {string} value2 Valeur par défaut
 * @returns {string} Valeur retenue
 */
export function nvl(value1, value2) {
    if (value1 === null || value1 === '')
        return value2;
    return value1;
}
export function json2array(json) {
    var result = [];
    var keys = Object.keys(json);
    keys.forEach(function (key) {
        if ((json[key] !== null) && (typeof json[key] === "object")) {
            var newResult = json2array(json[key]);
            for (var i = 0; i < newResult.length; i++) {
                var elem = [];
                elem.push(newResult[i][0]);
                elem.push(newResult[i][1]);
                result.push(elem);
            }
        }
        else {
            var elem = [];
            elem.push(key);
            elem.push(json[key]);
            result.push(elem);
        }
    });
    return result;
}
// code issu de jquery 3.4.1 => penser à mettre à jour jquery
// https://api.jquery.com/jQuery.escapeSelector/
export function escapeSelector(selector) {
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g;
    var fcssescape = function (ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0")
                return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    };
    return (selector + "").replace(rcssescape, fcssescape);
}
//# sourceMappingURL=lib.js.map